function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function cov_2rljdst9x0() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/FacebookAuth.tsx";
  var hash = "5d7346727b4b09046054c71ec49bc90433a30ffb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/FacebookAuth.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 25
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "1": {
        start: {
          line: 53,
          column: 22
        },
        end: {
          line: 62,
          column: 1
        }
      },
      "2": {
        start: {
          line: 54,
          column: 2
        },
        end: {
          line: 61,
          column: 4
        }
      },
      "3": {
        start: {
          line: 65,
          column: 48
        },
        end: {
          line: 73,
          column: 3
        }
      },
      "4": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 16
        }
      },
      "5": {
        start: {
          line: 75,
          column: 25
        },
        end: {
          line: 77,
          column: 3
        }
      },
      "6": {
        start: {
          line: 80,
          column: 58
        },
        end: {
          line: 80,
          column: 68
        }
      },
      "7": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 106,
          column: 6
        }
      },
      "8": {
        start: {
          line: 109,
          column: 26
        },
        end: {
          line: 118,
          column: 3
        }
      },
      "9": {
        start: {
          line: 110,
          column: 27
        },
        end: {
          line: 110,
          column: 37
        }
      },
      "10": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 111,
          column: 43
        }
      },
      "11": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 117,
          column: 9
        }
      },
      "12": {
        start: {
          line: 120,
          column: 23
        },
        end: {
          line: 129,
          column: 3
        }
      },
      "13": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 121,
          column: 44
        }
      },
      "14": {
        start: {
          line: 122,
          column: 37
        },
        end: {
          line: 122,
          column: 47
        }
      },
      "15": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 127,
          column: 9
        }
      },
      "16": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 128,
          column: 30
        }
      },
      "17": {
        start: {
          line: 131,
          column: 26
        },
        end: {
          line: 139,
          column: 3
        }
      },
      "18": {
        start: {
          line: 132,
          column: 38
        },
        end: {
          line: 132,
          column: 48
        }
      },
      "19": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 137,
          column: 9
        }
      },
      "20": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 138,
          column: 31
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 53,
            column: 22
          },
          end: {
            line: 53,
            column: 23
          }
        },
        loc: {
          start: {
            line: 53,
            column: 28
          },
          end: {
            line: 62,
            column: 1
          }
        },
        line: 53
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 68,
            column: 15
          },
          end: {
            line: 68,
            column: 16
          }
        },
        loc: {
          start: {
            line: 68,
            column: 21
          },
          end: {
            line: 70,
            column: 5
          }
        },
        line: 68
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 79,
            column: 3
          }
        },
        loc: {
          start: {
            line: 79,
            column: 18
          },
          end: {
            line: 107,
            column: 3
          }
        },
        line: 79
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 109,
            column: 26
          },
          end: {
            line: 109,
            column: 27
          }
        },
        loc: {
          start: {
            line: 109,
            column: 40
          },
          end: {
            line: 118,
            column: 3
          }
        },
        line: 109
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 120,
            column: 23
          },
          end: {
            line: 120,
            column: 24
          }
        },
        loc: {
          start: {
            line: 120,
            column: 37
          },
          end: {
            line: 129,
            column: 3
          }
        },
        line: 120
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 131,
            column: 26
          },
          end: {
            line: 131,
            column: 27
          }
        },
        loc: {
          start: {
            line: 131,
            column: 40
          },
          end: {
            line: 139,
            column: 3
          }
        },
        line: 131
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 99,
            column: 9
          },
          end: {
            line: 104,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 99,
            column: 9
          },
          end: {
            line: 99,
            column: 33
          }
        }, {
          start: {
            line: 100,
            column: 10
          },
          end: {
            line: 103,
            column: 12
          }
        }],
        line: 99
      },
      "1": {
        loc: {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 117,
            column: 8
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 14
          }
        }, {
          start: {
            line: 114,
            column: 6
          },
          end: {
            line: 117,
            column: 8
          }
        }],
        line: 113
      },
      "2": {
        loc: {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 127,
            column: 8
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 123,
            column: 14
          }
        }, {
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 127,
            column: 8
          }
        }],
        line: 123
      },
      "3": {
        loc: {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 137,
            column: 8
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 14
          }
        }, {
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 137,
            column: 8
          }
        }],
        line: 133
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5d7346727b4b09046054c71ec49bc90433a30ffb"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2rljdst9x0 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2rljdst9x0();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import FacebookLogin from 'react-facebook-login';
import { css } from '@emotion/react';
import { css as cn, cx } from '@emotion/css';
import { colors, radii, fontSizesNamed, fontWeights, fonts } from '@opendoor/bricks/theme/eero';
import { Image, Box, Flex } from '@opendoor/bricks/core';
import { ErrorPrompt } from '@opendoor/bricks/complex';
var ODFacebookButton = (cov_2rljdst9x0().s[0]++, /*#__PURE__*/css("background-color:", colors.neutrals0, ";border-radius:", radii.roundedSquare, ";border:2px solid ", colors.neutrals100, ";color:", colors.neutrals100, ";font-weight:", fontWeights.semibold, ";font-family:", fonts.sans, ";font-size:", fontSizesNamed.s0, ";cursor:pointer;height:50px;width:100%;font-size:", fontSizesNamed.s1, ";font-weight:", fontWeights.bold, ";display:flex;align-items:center;justify-content:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:ODFacebookButton;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
cov_2rljdst9x0().s[1]++;
export var iconFB = function iconFB() {
  cov_2rljdst9x0().f[0]++;
  cov_2rljdst9x0().s[2]++;
  return /*#__PURE__*/React.createElement(Image, {
    height: "16px",
    pr: 3,
    src: "https://imgdrop.imgix.net/b13d96ac33244eb1a52418e84ac5f889.png",
    alt: "Facebook logo"
  });
};
export var FacebookAuth = /*#__PURE__*/function (_React$Component) {
  _inherits(FacebookAuth, _React$Component);

  var _super = _createSuper(FacebookAuth);

  function FacebookAuth() {
    var _this;

    _classCallCheck(this, FacebookAuth);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", (cov_2rljdst9x0().s[5]++, {
      isSubmitError: false
    }));

    _defineProperty(_assertThisInitialized(_this), "handleFailure", (cov_2rljdst9x0().s[8]++, function (response) {
      cov_2rljdst9x0().f[3]++;

      var _ref = (cov_2rljdst9x0().s[9]++, _this.props),
          trackEvent = _ref.trackEvent;

      cov_2rljdst9x0().s[10]++;

      _this.setState({
        isSubmitError: true
      });

      cov_2rljdst9x0().s[11]++;
      (cov_2rljdst9x0().b[1][0]++, trackEvent) && (cov_2rljdst9x0().b[1][1]++, trackEvent('facebook-auth', 'failed', {
        details: response.details,
        error_code: response.error
      }));
    }));

    _defineProperty(_assertThisInitialized(_this), "handleAuth", (cov_2rljdst9x0().s[12]++, function (response) {
      cov_2rljdst9x0().f[4]++;
      cov_2rljdst9x0().s[13]++;

      _this.setState({
        isSubmitError: false
      });

      var _ref2 = (cov_2rljdst9x0().s[14]++, _this.props),
          onAuthed = _ref2.onAuthed,
          trackEvent = _ref2.trackEvent;

      cov_2rljdst9x0().s[15]++;
      (cov_2rljdst9x0().b[2][0]++, trackEvent) && (cov_2rljdst9x0().b[2][1]++, trackEvent('facebook-auth', 'authed', {
        email: response.email,
        name: response.name
      }));
      cov_2rljdst9x0().s[16]++;
      return onAuthed(response);
    }));

    _defineProperty(_assertThisInitialized(_this), "handleClicked", (cov_2rljdst9x0().s[17]++, function (response) {
      cov_2rljdst9x0().f[5]++;

      var _ref3 = (cov_2rljdst9x0().s[18]++, _this.props),
          onClicked = _ref3.onClicked,
          trackEvent = _ref3.trackEvent;

      cov_2rljdst9x0().s[19]++;
      (cov_2rljdst9x0().b[3][0]++, trackEvent) && (cov_2rljdst9x0().b[3][1]++, trackEvent('facebook-auth', 'clicked', {
        email: response.email,
        name: response.name
      }));
      cov_2rljdst9x0().s[20]++;
      return onClicked(response);
    }));

    return _this;
  }

  _createClass(FacebookAuth, [{
    key: "render",
    value: function render() {
      cov_2rljdst9x0().f[2]++;

      var _ref4 = (cov_2rljdst9x0().s[6]++, this.props),
          appId = _ref4.appId,
          cssClass = _ref4.cssClass,
          fields = _ref4.fields,
          size = _ref4.size,
          textButton = _ref4.textButton;

      cov_2rljdst9x0().s[7]++;
      return /*#__PURE__*/React.createElement(Box, {
        width: "100%"
      }, /*#__PURE__*/React.createElement(Flex, {
        justifyContent: "center",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(FacebookLogin, {
        appId: appId,
        autoLoad: false,
        cssClass: cssClass,
        fields: fields,
        onClick: this.handleClicked,
        callback: this.handleAuth,
        onFailure: this.handleFailure,
        size: size,
        icon: iconFB(),
        textButton: textButton,
        disableMobileRedirect: true,
        containerStyle: {
          width: '100%'
        }
      })), (cov_2rljdst9x0().b[0][0]++, this.state.isSubmitError) && (cov_2rljdst9x0().b[0][1]++, /*#__PURE__*/React.createElement(ErrorPrompt, {
        message: "Sorry, the attempt to sign in with Facebook failed. Please try again.",
        paddingBottom: "16px"
      })));
    }
  }]);

  return FacebookAuth;
}((React.Component));

_defineProperty(FacebookAuth, "defaultProps", (cov_2rljdst9x0().s[3]++, {
  cssClass: cx( /*#__PURE__*/cn(ODFacebookButton, process.env.NODE_ENV === "production" ? "" : ";label:defaultProps;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")),
  fields: 'name,email,picture',
  onClicked: function onClicked() {
    cov_2rljdst9x0().f[1]++;
    cov_2rljdst9x0().s[4]++;
    return {};
  },
  size: 'medium',
  textButton: 'Continue with Facebook'
}));